<script>
    export default {
        name: "GuaranteeItem",
        props: {
            item: Object,
        },
    };
</script>

<template>
    <div class="guarantee-item">
        <div class="guarantee-item__icon" :style="{ backgroundColor: item.background }">
            <img :src="`/static/madrobots/guarantee/${item.icon}?v=25122023`" alt="" />
        </div>

        <div class="guarantee-item__info">
            <div class="guarantee-item__title">{{ item.title }}</div>
            <div class="guarantee-item__text" v-html="item.text"></div>
        </div>
    </div>
</template>

<style lang="scss">
    .guarantee-item {
        display: flex;
        @include bp($bp-desktop-sm) {
            padding: 20px;
            height: 100%;
        }
    }

    .guarantee-item__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        @include box(50px);
        margin-right: 15px;
        border-radius: 50%;
        pointer-events: none;
        img {
            @include box(20px);
        }
        @include bp($bp-desktop-sm) {
            align-self: center;
            @include box(80px);
            margin-right: 20px;
            img {
                @include box(40px);
            }
        }
    }

    .guarantee-item__title {
        margin-bottom: 5px;
        color: #364758;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 8px;
            font-size: 18px;
            line-height: 18px;
        }
    }

    .guarantee-item__text {
        color: var(--secondary-text);
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        @include bp($bp-desktop-sm) {
            color: #475362;
            font-size: 12px;
            font-weight: 500;
            line-height: 20px;
        }
    }
</style>
